/* tslint:disable */

import Moment from 'moment';
import { Log } from 'ng2-logger';
import React, { Dispatch } from 'react';
import { Bar, Doughnut } from 'react-chartjs-2';
import { connect } from 'react-redux';
import { Label, Modal } from 'reactstrap';
import { Common } from '../../../../core/common';
import Translator from '../../../../core/i18n';
import { IAction, IAppState } from '../../../../models/action/core';
import { IActivityStatsProps } from '../../../../models/components/activity-report-modal';
import * as Actions from '../../../../store/actions/coursePage';
import * as BackGroundActions from '../../../../store/actions/background';
import Loading from '../../../loading/loading';
import { SecureImage } from '../../../core/secureImage';
import { CourseContentMenuType } from '../../../../models/enums/CourseContentMenuType';
import ReportModalDetails from './activity-report-details'
import Chart from 'chart.js';
import { ActivityType, ActivityTypeEnums } from '../../../../models/enums/ActivityType';
import { VirtualClassType } from '../../../../models/enums/VirtualClassType';
import { VirtualClassReportType } from '../../../../models/enums/VirtualClassReportType';
import Tooltip from '../../../tooltip/main';
import Truncater from '../../../truncater/main';
import { Button } from '../../../ui-elements/main';

const _logger = Log.create('Processing Activity');
const T = Translator.create();
let _common: Common;
let canvasElement: any;

class ReportModal extends React.Component<IActivityStatsProps, any> {
    constructor(props: any) {
        super(props);
        _common = new Common();
        canvasElement = React.createRef();
    }

    componentDidMount() {
        setTimeout(() => {
            this.getClassActivityReport();
        }, 1);
        const activityId = this.props.activityCardItems && this.props.activityCardItems[0] && this.props.activityCardItems[0].activityId;
        this.props.dispatch(Actions.ActivityReportDetailGetAction(this.props.activityId ? this.props.activityId! : activityId!, this.props.coursePageClassId!, 'getActivityDetailReport', 'get'));

        setTimeout(() => {
            const ctx_bar = canvasElement.current.getContext('2d');
            let data: number[] = [0, 0, 0, 0, 0, 0, 0];
            if (this.props.classActivityReport && this.props.classActivityReport.lastWeekViewStats) {
                this.props.classActivityReport!.lastWeekViewStats.forEach(element => {
                    data[Moment(element.date).day() === 0 ? 6 : Moment(element.date).day() - 1] = element.count;
                });
            }
            const myChart_bar = new Chart(ctx_bar, {
                type: 'bar',
                data: {
                    labels: [T.t('r_monday'), T.t('r_tuesday'), T.t('r_wednesday'), T.t('r_thursday'), T.t('r_friday'), T.t('r_saturday'), T.t('r_sunday')],
                    datasets: [{
                        data: data,
                        backgroundColor: [
                            'rgba(230, 174, 115, .75)',
                            'rgba(230, 174, 115, .75)',
                            'rgba(230, 174, 115, .75)',
                            'rgba(230, 174, 115, .75)',
                            'rgba(230, 174, 115, .75)',
                            'rgba(230, 174, 115, .75)',
                            'rgba(230, 174, 115, .75)',
                        ],
                        borderColor: [
                            'rgb(230, 174, 115)',
                            'rgb(230, 174, 115)',
                            'rgb(230, 174, 115)',
                            'rgb(230, 174, 115)',
                            'rgb(230, 174, 115)',
                            'rgb(230, 174, 115)',
                            'rgb(230, 174, 115)',
                        ],
                        borderWidth: 1,
                        // borderSkipped:false,
                        barPercentage: 0.75,
                        categoryPercentage: 0.75,
                    }]
                },
                options: {
                    legend: {
                        display: false
                    },
                    maintainAspectRatio: false,
                    scales: {

                        yAxes: [{
                            display: false,
                            gridLines: {
                                display: false
                            },
                        }],
                        xAxes: [{
                            display: true,
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                callback: function (value) {
                                    return value.toString().substring(0, 1);
                                }
                            }
                        }],



                    },
                    plugins: {
                        legend: {
                            display: false,
                        }
                    }
                }
            });
        }, 1000);



    }

    getClassActivityReport() {
        const classId = this.props.coursePageClassId!;
        const activityId = this.props.activityCardItems && this.props.activityCardItems[0] && this.props.activityCardItems[0].activityId;
        const groupId = this.props.groupId ? this.props.groupId : '0';

        this.props.dispatch(Actions.getCourseClassActivityReport(classId, this.props.activityId ? this.props.activityId! : activityId!, groupId, false, 'getCourseClassActivityReport', 'get'));
    }

    downloadActivityReport(classId: string, activityId: string, isDetailed: boolean, virtualClassReportType?: VirtualClassReportType) {
        this.props.dispatch(
            BackGroundActions.GetActivityReport(activityId, classId, isDetailed, virtualClassReportType ?? VirtualClassReportType.ActivityReport, 'getCourseClassActivityReport', 'get')
        );
    }

    setClose = (refresh: boolean = false) => {
        if (this.props.onClose) {
            this.props.onClose(refresh);
        }
    };

    setCloseModal = () => {
        this.setClose();
    };

    renderReportDownloadButtons = (activityType: ActivityType, activityCard: any) => {

        const classId = this.props.coursePageClassId!;
        const activityId = activityCard ? activityCard.activityId : this.props.activityCardItems! && this.props.activityCardItems[0] && this.props.activityCardItems[0].activityId;
        return (
            <div className="options d-inline-flex align-items-center">
                {
                    (activityType === ActivityTypeEnums[ActivityTypeEnums.Survey] || activityType === ActivityTypeEnums[ActivityTypeEnums.Exam]) ?

                        <Button
                            button_type={'secondary'}
                            text={T.t('r_download_detailed_report')}
                            size={'medium'}
                            iconPosition='left'
                            materialicon='cloud_download'
                            onClick={() => this.downloadActivityReport(classId, activityId, true)}
                        />
                        : ''
                }

                {
                    (activityType === ActivityType.VirtualClass && (activityCard?.virtualClassType === VirtualClassType.PerculusPlus || activityCard?.virtualClassType === VirtualClassType.Perculus)) ?
                        <>

                            <Button
                                button_type={'secondary'}
                                text={T.t('r_virtual_class_session_statistics_report')}
                                size={'medium'}
                                iconPosition='left'
                                materialicon='cloud_download'
                                onClick={() => this.downloadActivityReport(classId, activityId, true, VirtualClassReportType.StatisticalParticipationReport)}
                            />
                            <Button
                                button_type={'secondary'}
                                text={T.t('r_virtual_class_session_statistics_report')}
                                size={'medium'}
                                iconPosition='left'
                                materialicon='cloud_download'
                                onClick={() => this.downloadActivityReport(classId, activityId, true, VirtualClassReportType.SessionStatisticsReport)}
                            />
                        </>
                        : ''
                }


                <Button
                    button_type={'secondary'}
                    text={activityType === ActivityType.VirtualClass && (activityCard?.virtualClassType === VirtualClassType.PerculusPlus || activityCard?.virtualClassType === VirtualClassType.Perculus) ? T.t('r_virtual_class_participation_report') : T.t('r_download')}
                    size={'medium'}
                    iconPosition='left'
                    onClick={() => this.downloadActivityReport(classId, activityId, false)}
                    materialicon='cloud_download'
                />
            </div>
        )
    }

    renderViewerStats = () => {

        const latestViewers = this.props.classActivityReport?.latestViewers;
        const mostViewers = this.props.classActivityReport?.mostViewers;

        return (
            <div className="row">
                <div className="col-md-6">
                    <div className="white-box">
                        <h6>
                            {T.t('r_activity_report_latest_viewers')}
                            {/* <span>
                                        Tümü <i className="material-icons ml-2">arrow_forward</i>
                                    </span> */}
                        </h6>
                        <table className="table">
                            <thead>
                                <tr>
                                    <td>{T.t('r_name')}</td>
                                    <td>{T.t('r_datetime_picker_date')}</td>
                                    <td>{T.t('r_display')}</td>
                                </tr>
                            </thead>
                            <tbody>
                                {latestViewers?.length
                                    ? latestViewers.map((user: any) => (
                                        <tr key={user.userId}>
                                            <td>
                                                <div className="media align-items-center">
                                                    <SecureImage
                                                        imageUrl={user.profilePicUrl ? user.profilePicUrl : ''}
                                                        style={{}}
                                                        class={'media align-items-center mr-2'}
                                                    />
                                                    <div className="media-body">
                                                        <Tooltip data={user?.firstName + ' ' + user?.lastName} position='top' delay={.3}>
                                                            <Truncater length={36} as='span' text={user?.firstName + ' ' + user?.lastName}  />
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                {user?.lastViewDate ? (
                                                    Moment(user?.lastViewDate).format(
                                                        _common.GetDateFormatFromPrefrences(this.props.userPreferences, 1)
                                                    )
                                                ) : ''}
                                            </td>
                                            <td>{user.viewCount}</td>
                                        </tr>
                                    ))
                                    : null}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="white-box">
                        <h6> {T.t('r_activity_report_most_viewers')}</h6>
                        <table className="table">
                            <thead>
                                <tr>
                                    <td>{T.t('r_name')}</td>
                                    <td>{T.t('r_datetime_picker_date')}</td>
                                    <td>{T.t('r_display')}</td>
                                </tr>
                            </thead>
                            <tbody>
                                {mostViewers?.length
                                    ? mostViewers.map((user: any) => (
                                        <tr key={user.userId}>
                                            <td>
                                                <div className="media align-items-center">
                                                    <SecureImage
                                                        imageUrl={user.profilePicUrl ?? ''}
                                                        style={{}}
                                                        class={'media align-items-center mr-2'}
                                                    />
                                                    <div className="media-body">
                                                        <Tooltip data={user?.firstName + ' ' + user?.lastName} position='top' delay={.3}>
                                                            <Truncater length={36} as='span' text={user?.firstName + ' ' + user?.lastName}  />
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                {user?.lastViewDate ? (
                                                    Moment(user.lastViewDate).format(
                                                        _common.GetDateFormatFromPrefrences(this.props.userPreferences, 1)
                                                    )
                                                ) : ''}
                                            </td>
                                            <td>{user.viewCount > 0 ? user.viewCount : T.t('r_activity_report_not_started')}</td>
                                        </tr>
                                    ))
                                    : null}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        let activityCard = null;
        if (this.props.courseContentMenuType !== CourseContentMenuType.weekAndActivity && this.props.activityCardItems && this.props.activityCardItems.length) {
            activityCard = this.props.activityCardItems.find(item => item.activityId === this.props.activityId);
        }

        const programName = this.props.coursePageclassInformation?.programName;
        const courseName = this.props.coursePageclassInformation?.courseName;

        const activityType = activityCard ? activityCard.activityType : this.props.activityCardItems! && this.props.activityCardItems[0] && this.props.activityCardItems[0].activityType;

        const activityName = activityCard ? activityCard.name : this.props.activityCardItems! && this.props.activityCardItems[0] && this.props.activityCardItems[0].name;

        const viewStats = this.props.classActivityReport?.viewStats;
        const chartStats = this.props.classActivityReport?.chartStats;

        const data = {
            labels: [
                `${T.t('r_activity_report_completed')}`,
                `${T.t('r_activity_report_not_completed')}`,
                `${T.t('r_activity_report_not_started')}`,
                `${T.t('r_activity_report_failed')}`
            ],
            datasets: [
                {
                    data: [
                        chartStats?.completed,
                        chartStats?.incompleted,
                        chartStats?.notStarted,
                        chartStats?.failed
                    ],
                    backgroundColor: ['#20c997', '#36A2EB', '#FFCE56', '#FF6384'],
                    hoverBackgroundColor: ['#20c997', '#36A2EB', '#FFCE56', '#FF6384']
                }
            ]
        };
        return (
            <Modal
                className="question-modal exam-modal-stats"
                isOpen={this.props.modalIsOpen}
                toggle={this.setCloseModal}
                style={{ maxWidth: '1150px' }}
            >
                <div className="modal-header border-0 d-flex justify-content-between mb-2 mb-md-0">
                    <h6 className="modal-title d-inline-flex align-items-center" id="exampleModalLabel">
                        <i className="material-icons">{_common.GetMaterialActivityIcons(activityType)}</i>
                        &nbsp;
                        {T.t('r_statistics', { 0: T.t('r_activity_type_' + activityType) })}
                    </h6>
                    <button type="button" className="close p-0" style={{ marginInlineEnd: "0px" }} onClick={this.setCloseModal} aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <Loading spinnerId={'getCourseClassActivityReport'} width={100} />
                    <div className="buyer-stats announcement-heading mt-0 p-0 border-bottom-0">
                        <div style={{wordBreak: 'break-word'}}>
                            <span>
                                {programName} - {courseName}
                            </span>
                            <h6>{activityName}</h6>
                        </div>
                        <div className="announcement position-relative">
                            {activityCard?.activityType == ActivityType.VirtualClass &&
                                (
                                    <Tooltip data={T.t('r_virtual_reflected_info')} position='top'>
                                        <img src={_common.GetDefaultIcons('info')} alt="" />
                                    </Tooltip>
                                )
                            }
                        </div>
                        {this.renderReportDownloadButtons(activityType, activityCard)}

                    </div>
                    <div className="row">
                        <ReportModalDetails ActivityReportDetail={this.props.ActivityReportDetail ? this.props.ActivityReportDetail : ''} />
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="white-box">
                                <Doughnut
                                    data={data}
                                    options={{
                                        legend: {
                                            position: 'right'
                                        },
                                        cutoutPercentage: 70
                                    }}
                                />
                                <hr />
                                <p className="text-center">
                                    {T.t('r_total_participants')}: <b>{chartStats?.total}</b>
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6 col-12 h-200 pr-0">
                            <div className="chart_section">
                                <div className="report_chart_bar">
                                    <canvas ref={canvasElement}></canvas>
                                </div>
                                <div className="chart_legends">
                                    <div className="legend">
                                        <span className="legend_small_text">{T.t('r_my_user_teacher_calendar_today')}</span>
                                        <span className="legend_text">{viewStats?.today}</span>
                                    </div>

                                    <div className="legend">
                                        <span className="legend_small_text">{T.t('r_my_user_teacher_calendar_yesterday')}</span>
                                        <span className="legend_text">{viewStats?.yesterday ? (viewStats.yesterday - viewStats.today) : 0}</span>
                                    </div>

                                    <div className="legend">
                                        <span className="legend_small_text ">{T.t('r_activity_report_last_week')}</span>
                                        <span className="legend_text">{viewStats?.lastWeek}</span>
                                    </div>

                                    <div className="legend">
                                        <span className="legend_small_text ">{T.t('r_activity_report_last_month')}</span>
                                        <span className="legend_text">{viewStats?.lastMonth}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.renderViewerStats()}
                </div>
                <div className="modal-footer">
                    <div>
                        <Button
                            button_type={'secondary'}
                            text={T.t('r_fileUpload_cancel')}
                            size={'medium'}
                            onClick={this.setCloseModal}
                            iconPosition='left'
                            materialicon='close'
                        />
                    </div>
                </div>
                {/* </div> */}
            </Modal >
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IActivityStatsProps): IActivityStatsProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IActivityStatsProps = Object.assign({}, ownProps, {
        userType: state.login.identitiy.userType,
        coursePageClassId: state.coursePage.coursePageClassId,
        courseContentWeekActivities: state.coursePage.courseContentWeekActivities,
        courseContentMenuType: state.coursePage.courseContentMenuType,
        activityCardItems: state.coursePage.activityCard,
        classActivityReport: state.coursePage.classActivityReport,
        coursePageclassInformation: state.coursePage.coursePageclassInformation,
        userPreferences: state.profile.userPreferences.preferences,
        groupId: state.assignment.groupId,
        ActivityReportDetail: state.coursePage.ActivityReportDetail
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.coursePage.classActivityReport === prev.coursePage.classActivityReport &&
        next.coursePage.activityCard === prev.coursePage.activityCard;
    return ret;
};

const CProcessingActivity = connect(
    mapStateToProps,
    dispatchProps,
    null,
    { areStatesEqual }
)(ReportModal);

export default CProcessingActivity;
